import { Resource as s, API as i } from "@coveo/platform-client";
const e = class e extends s {
  getGlobalGroupPrivileges() {
    return this.api.get("/rest/globalprivileges");
  }
  getUserPrivileges(t) {
    return this.api.get(
      `${e.baseUrl}/${t || i.orgPlaceholder}/members/privileges`
    );
  }
};
e.baseUrl = "/rest/organizations";
let r = e;
export {
  r as PrivilegesResource
};
//# sourceMappingURL=PrivilegesResource.js.map
